import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

export default function WarehouseEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [row, setRow] = useState({ title: "", status: "active" });
  const language = useUserLanguage();
const { translations } = useTranslations(language);
const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/warehouses/${id}`)
      .then((res) => {
        setRow(res.data);
      });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/warehouses/${id}`,
      row
    );
   toast.success(getText("WAREHOUSE_UPDATED_SUCCESS"));

    navigate("/warehouses/table");
  };

  return (
    <div className="container card p-4 mt-3">

      <form onSubmit={handleSubmit}>
        <label className="form-label fw-bold">{getText("WAREHOUSE_NAME_LABEL")}</label>
        <input
          className="form-control mb-3"
          value={row.title}
          onChange={(e) => setRow({ ...row, title: e.target.value })}
        />
        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
            {getText("SAVE")}
          </button>
        </div>
      </form>
    </div>
  );
}
